import { Organizer } from "./types";

export const organizersTable: Array<Organizer> = [
  {
    id: "unknown",
    name: "Neznámý",
    websiteUrl: "",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "cnid",
    name: "ČNID - České Národní Improvizační Divadlo",
    websiteUrl: "www.cnid.cz",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "padenapade",
    name: "Pade na pade",
    websiteUrl: "www.padenapade.com",
    facebookCalendarId: "Pade na Pade",
    language: "cs",
  },
  {
    id: "alibiprochyby",
    name: "Alibi pro Chyby",
    websiteUrl: "www.facebook.com/Alibi.pro.Chyby",
    facebookCalendarId: "Alibi pro Chyby",
    language: "cs",
  },
  {
    id: "nedivse",
    name: "NeDivSe - Neobvyklá Divadelní Sešlost",
    websiteUrl: "www.facebook.com/nedivse",
    facebookCalendarId: "NeDivSe",
    language: "cs",
  },
  {
    id: "justimpro",
    name: "Just! Impro",
    websiteUrl: "www.justimpro.cz",
    facebookCalendarId: "Just! Impro",
    language: "cs",
  },
  {
    id: "polocasnapadu",
    name: "Poločas nápadu",
    websiteUrl: "www.polocas-napadu.cz",
    facebookCalendarId: "Poločas nápadu",
    language: "cs",
  },
  {
    id: "fofrvzupanu",
    name: "Fofr v županu",
    websiteUrl: "www.facebook.com/fofr.impro",
    facebookCalendarId: "Fofr v županu",
    language: "cs",
  },
  {
    id: "improvariace",
    name: "Improvariace",
    websiteUrl: "www.improvariace.cz",
    facebookCalendarId: "IMPROvariace",
    language: "cs",
  },
  {
    id: "divadloimprovizaceodvaz",
    name: "Divadlo improvizace ODVAZ",
    websiteUrl: "www.odvaz.eu",
    facebookCalendarId: "Divadlo improvizace ODVAZ",
    language: "cs",
  },
  {
    id: "blancinybileboty",
    name: "Blančiny bílé boty",
    websiteUrl: "www.facebook.com/profile.php?id=100066485512990",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "skolaimprovizace",
    name: "Škola improvizace",
    websiteUrl: "www.skolaimprovizace.cz",
    facebookCalendarId: "Škola improvizace",
    language: "cs",
  },
  {
    id: "instantnigaucink",
    name: "Instantní Gaučink",
    websiteUrl: "www.facebook.com/suroskard",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "blr",
    name: "Blood, Love and Rhetoric Improv Comedy",
    websiteUrl: "www.facebook.com/BloodLoveRhetoricEvents",
    facebookCalendarId: "Blood\\, Love and Rhetoric Improv Comedy",
    language: "en",
  },
  {
    id: "vip",
    name: "V.I.P",
    websiteUrl: "www.impro.vip",
    facebookCalendarId: "VIP impro",
    language: "cs",
  },
  {
    id: "kecky",
    name: "Kecky",
    websiteUrl: "www.improkecky.cz",
    facebookCalendarId: "Kecky",
    language: "cs",
  },
  {
    id: "standartnikabaret",
    name: "Vosto5 - Stand'artní kabaret",
    websiteUrl: "www.vosto5.cz/repertoar/standartni-kabaret",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "paletaci",
    name: "Paleťáci",
    websiteUrl: "www.paletaci.cz",
    facebookCalendarId: "Paleťáci",
    language: "cs",
  },
  {
    id: "bafni",
    name: "Bafni",
    websiteUrl: "www.bafni.cz",
    facebookCalendarId: "Bafni - improvizační divadlo",
    language: "cs",
  },
  {
    id: "divadloodvaz",
    name: "Divadlo Odvaz",
    websiteUrl: "www.odvaz.eu",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "divadlo301",
    name: "Divadlo 301",
    websiteUrl: "www.facebook.com/Divadlo301",
    facebookCalendarId: "Divadlo 301",
    language: "cs",
  },
  {
    id: "bizoni",
    name: "B.I.Z.O.N.I.",
    websiteUrl: "www.improbizoni.cz",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "myklucicospoluchodime",
    name: "My kluci, co spolu chodíme",
    websiteUrl: "www.facebook.com/mykluci",
    facebookCalendarId: "My kluci\\, co spolu chodíme / Us boys who go out together",
    language: "cs",
  },
  {
    id: "divadlokellari",
    name: "Divadlo Kellari",
    websiteUrl: "www.divadlokellari.cz",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "kabinetimprovizace",
    name: "Kabinet improvizace",
    websiteUrl: "www.kabinetimprovizace.cz",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "zivapedagogika",
    name: "Živá pedagogika",
    websiteUrl: "www.zivapedagogika.cz",
    facebookCalendarId: "Atelier živé pedagogiky a tvorby",
    language: "cs",
  },
  {
    id: "321jedem",
    name: "321jedem!",
    websiteUrl: "www.321jedem.cz",
    facebookCalendarId: "321jedem",
    language: "cs",
  },
  {
    id: "lisky",
    name: "Lísky",
    websiteUrl: "www.improlisky.cz",
    facebookCalendarId: "Lísky - boskovický improvizační tým",
    language: "cs",
  },
  {
    id: "meandry",
    name: "Meandry",
    websiteUrl: "www.facebook.com/meandrovani",
    facebookCalendarId: "Meandry - improvizační skupina",
    language: "cs",
  },
  {
    id: "nepripraveni",
    name: "Nepřipravení",
    websiteUrl: "www.nepripraveni.cz",
    facebookCalendarId: "Nepřipravení - improvizace a zábava",
    language: "cs",
  },
  {
    id: "impra",
    name: "Impra",
    websiteUrl: "www.hereckaimprovizace.cz",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "frmol",
    name: "Frmol",
    websiteUrl: "www.improfrmol.cz",
    facebookCalendarId: "Impro FrMol",
    language: "cs",
  },
  {
    id: "pragueimprovnetwork",
    name: "Prague Improv Network",
    websiteUrl: "www.facebook.com/pragueimprovnetwork",
    facebookCalendarId: "",
    language: "en",
  },
  {
    id: "improvizacecz",
    name: "Improvizace.cz",
    websiteUrl: "www.improvizace.cz",
    facebookCalendarId: "improvizace.cz",
    language: "cs",
  },
  {
    id: "imperfectionists",
    name: "The Imperfectionists",
    websiteUrl: "www.facebook.com/imperfectionists.prague",
    facebookCalendarId: "The Imperfectionists",
    language: "en",
  },
  {
    id: "therandoms",
    name: "The Randoms",
    websiteUrl: "www.therandoms.cz",
    facebookCalendarId: "The Randoms",
    language: "en",
  },
  {
    id: "saysomethingcz",
    name: "saysomething.cz",
    websiteUrl: "www.saysomething.cz",
    facebookCalendarId: "saysomething.cz",
    language: "cs",
  },
  {
    id: "altf4",
    name: "ALT + F4",
    websiteUrl: "www.facebook.com/divadloaltf4",
    facebookCalendarId: "ALT + F4",
    language: "cs",
  },
  {
    id: "kis",
    name: "KIŠ",
    websiteUrl: "www.tyrkis.cz",
    facebookCalendarId: "KIŠ",
    language: "cs",
  },
  {
    id: "creativedifferences",
    name: "Creative Differences",
    websiteUrl: "www.facebook.com/creativedifferencespragueimprov",
    facebookCalendarId: "Creative Differences - Prague Improv",
    language: "en",
  },
  {
    id: "skola21",
    name: "Škola 21",
    websiteUrl: "www.skola21.com",
    facebookCalendarId: "Škola 21",
    language: "cs",
  },
  {
    id: "kopr",
    name: "K.Op.R",
    websiteUrl: "www.facebook.com/improkopr",
    facebookCalendarId: "KOPR",
    language: "cs",
  },
  {
    id: "imjoy",
    name: "Imjoy",
    websiteUrl: "www.facebook.com/improvizaceimjoy",
    facebookCalendarId: "Imjoy",
    language: "cs",
  },
  {
    id: "minimpromalismus",
    name: "Minimpromalismus",
    websiteUrl: "www.facebook.com/minimpromalismus",
    facebookCalendarId: "Minimpromalismus",
    language: "cs",
  },
  {
    id: "improdva",
    name: "Improdva",
    websiteUrl: "www.facebook.com/improdva",
    facebookCalendarId: "Improdva",
    language: "cs",
  },
  {
    id: "improsamevody",
    name: "IMPRO Samé vody",
    websiteUrl: "www.facebook.com/samevody",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "nevyzadanarada",
    name: "Nevyžádaná rada",
    websiteUrl: "www.facebook.com/svahilec",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "valouny",
    name: "Valouny",
    websiteUrl: "www.facebook.com/valouny",
    facebookCalendarId: "VALOUNY",
    language: "cs",
  },
  {
    id: "michaelapuchalka",
    name: "Michaela Puchalka",
    websiteUrl: "www.improspace.com",
    facebookCalendarId: "Michaela Puchalka",
    language: "cs",
  },
  {
    id: "kalegro",
    name: "Herecké workshopy Kalegro",
    websiteUrl: "www.herecke-workshopy.cz",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "divadloprocity",
    name: "Divadlo Procity",
    websiteUrl: "www.divadloprocity.cz",
    facebookCalendarId: "Divadlo Procity",
    language: "cs",
  },
  {
    id: "necijehneci",
    name: "Něčí Jehněčí",
    websiteUrl: "www.facebook.com/improbabice",
    facebookCalendarId: "Něčí jehněčí - improvizační tým",
    language: "cs",
  },
  {
    id: "longformy",
    name: "Longformy",
    websiteUrl: "www.facebook.com/longformy",
    facebookCalendarId: "Longformy",
    language: "cs",
  },
  {
    id: "veski",
    name: "VE.ŠK.I.",
    websiteUrl: "www.facebook.com/profile.php?id=100089439765100",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "katerinaburesova",
    name: "Kateřina Burešová",
    websiteUrl: "www.buresovakaterina.cz",
    facebookCalendarId: "Kateřina Burešová",
    language: "cs",
  },
  {
    id: "scriptforbrains",
    name: "Script for Brains",
    websiteUrl: "www.pragueimprov.com",
    facebookCalendarId: "Script for Brains",
    language: "en",
  },
  {
    id: "olivy",
    name: "Olivy",
    websiteUrl: "www.olivy.org",
    facebookCalendarId: "OLIVY - olomoucká improvizace O.Li.V.Y.",
    language: "cs",
  },
  {
    id: "instantnigaucink",
    name: "Instantní Gaučink",
    websiteUrl: "www.facebook.com/suroskard",
    facebookCalendarId: "Instantní Gaučink",
    language: "cs",
  },
  {
    id: "allimp",
    name: "All Imp",
    websiteUrl: "www.divadloallimp.cz",
    facebookCalendarId: "All Imp",
    language: "cs",
  },
  {
    id: "dortvkapse",
    name: "Dort v kapse",
    websiteUrl: "www.facebook.com/dortvkapse",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "karel",
    name: "Karel",
    websiteUrl: "www.facebook.com/karel.impro",
    facebookCalendarId: "Karel",
    language: "cs",
  },
  {
    id: "nickford",
    name: "Nick Ford",
    websiteUrl: "",
    facebookCalendarId: "Nick Ford",
    language: "en",
  },
  {
    id: "plamenaci",
    name: "Plameňáci",
    websiteUrl: "www.plamenaci.cz",
    facebookCalendarId: "Plameňáci",
    language: "cs",
  },
  {
    id: "marianazacharova",
    name: "Mariana Zacharová",
    websiteUrl: "",
    facebookCalendarId: "Mariana Zacharová",
    language: "cs",
  },
  {
    id: "petraandrasik",
    name: "Petra Andrášik",
    websiteUrl: "www.zazemi.org",
    facebookCalendarId: "Petra Andrášik",
    language: "cs",
  },
  {
    id: "monikanevolova",
    name: "Monika Nevolová ",
    websiteUrl: "umenivpraci.cz",
    facebookCalendarId: "Monika Mondieu Nevolová",
    language: "cs",
  },
  {
    id: "improinstitut",
    name: "Impro Institut",
    websiteUrl: "www.improinstitut.cz ",
    facebookCalendarId: "IMPRO INSTITUT",
    language: "cs",
  },
  {
    id: "improvacademy",
    name: "The Improv Academy",
    websiteUrl: "www.improvacademy.cz",
    facebookCalendarId: "",
    language: "en",
  },
  {
    id: "howtoflow",
    name: "How to flow",
    websiteUrl: "www.howtoflow.cz",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "zadvermi",
    name: "O. s. ZA DVEŘMI",
    websiteUrl: "www.divadlo-zadvermi.cz",
    facebookCalendarId: "O. s. ZA DVEŘMI",
    language: "cs",
  },
  {
    id: "sis",
    name: "Šejkspírovská improvizovaná společnost",
    websiteUrl: "www.facebook.com/profile.php?id=61556487249447",
    facebookCalendarId: "Šejkspírovská improvizovaná společnost",
    language: "cs",
  },
  {
    id: "cechovovafuska",
    name: "Čechovova fuška",
    websiteUrl: "www.facebook.com/profile.php?id=61558151027838",
    facebookCalendarId: "Čechovova fuška - improvizační skupina",
    language: "cs",
  },
  {
    id: "improvize",
    name: "Improvize",
    websiteUrl: "www.facebook.com/improvize1",
    facebookCalendarId: "Improvize",
    language: "cs",
  },
  {
    id: "nobuco",
    name: "Nobuco",
    websiteUrl: "www.nobuco.cz/",
    facebookCalendarId: "Nobuco",
    language: "cs",
  },
  {
    id: "kabinet-impro-dovednosti",
    name: "Kabinet Improvizačních Dovedností",
    websiteUrl: "www.kabinetimprovizace.cz",
    facebookCalendarId: "Kabinet Improvizačních Dovedností",
    language: "cs",
  },
  {
    id: "vyvar",
    name: "Vývar",
    websiteUrl: "www.facebook.com/profile.php?id=61556462099186",
    facebookCalendarId: "Improvizační skupina Vývar",
    language: "cs",
  },
  {
    id: "improvykrik",
    name: "improVýkřik",
    websiteUrl: "https://www.facebook.com/VYKRIK",
    facebookCalendarId: "Improvizační skupina Výkřik",
    language: "cs",
  },
  {
    id: "cai",
    name: "Club Anonymních Improvizátorů",
    websiteUrl: "https://www.facebook.com/profile.php?id=61558355502244",
    facebookCalendarId: "Club Anonymních Improvizátorů ",
    language: "cs",
  },
  {
    id: "kokoloko",
    name: "Kokoloko",
    websiteUrl: "https://www.kokoloko.cz",
    facebookCalendarId: "Kokoloko_production",
    language: "cs",
  },
  {
    id: "exit87",
    name: "Exit 87",
    websiteUrl: "https://www.facebook.com/profile.php?id=61562645797839",
    facebookCalendarId: "Exit 87",
    language: "en",
  },
  {
    id: "tlak",
    name: "Improvizační jednotka TLAK",
    websiteUrl: "https://www.facebook.com/profile.php?id=61569683368568",
    facebookCalendarId: "Improvizační jednotka TLAK",
    language: "cs",
  },
  {
    id: "vezmikapranapilates",
    name: "Vezmi kapra na pilates",
    websiteUrl: "https://www.facebook.com/profile.php?id=61564930971632",
    facebookCalendarId: "Vezmi kapra na pilates",
    language: "cs",
  },
  {
    id: "radioivo",
    name: "RÁDIO IVO",
    websiteUrl: "https://www.facebook.com/radio.ivo",
    facebookCalendarId: "RADIO IVO",
    language: "cs",
  },
  {
    id: "godsavedramaqueen",
    name: "God Save the Drama Queen",
    websiteUrl: "https://www.facebook.com/profile.php?id=61571947091047",
    facebookCalendarId: "",
    language: "cs",
  },
  {
    id: "letniimprouterky",
    name: "Letní improúterky",
    websiteUrl: "https://www.facebook.com/improuterky",
    facebookCalendarId: "Letní improúterky",
    language: "cs",
  },
  {
    id: "improhack",
    name: "ImproHack",
    websiteUrl: "https://www.facebook.com/profile.php?id=61575038140416",
    facebookCalendarId: "ImproHack",
    language: "cs",
  },
  {
    id: "pilulky",
    name: "Pilulky",
    websiteUrl: "https://www.facebook.com/profile.php?id=100054481089470",
    facebookCalendarId: "Pilulky",
    language: "cs",
  },
  {
    id: "smecka",
    name: "smečka",
    websiteUrl: "https://www.facebook.com/smecka.impro",
    facebookCalendarId: "Improvizační soubor smečka.",
    language: "cs",
  },
  {
    id: "jokedivision",
    name: "Joke Division",
    websiteUrl: "https://www.facebook.com/jokedivisioncz",
    facebookCalendarId: "Joke Division CZ",
    language: "cs",
  },
  {
    id: "reknivez",
    name: "Řeknivěž",
    websiteUrl: "https://www.facebook.com/reknivez",
    facebookCalendarId: "Řeknivěž",
    language: "cs",
  },
];
